import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReactHtmlParser from 'html-react-parser';
import { getMethodologyData } from '../../api';

const Accordion = props => {
	
	const _handleClick = e => {
		e.currentTarget.classList.toggle('active');
	}
	
	let title = (<h2 className="accordion-title" onClick={ (e) => _handleClick(e) }>{props.title}</h2>);
	if (props.level > 1)
	{
		title = (<h3 className="accordion-title" onClick={ (e) => _handleClick(e) }>{props.title}</h3>)
	}

	return (
		<div>
			{ title }
			<div className='accordion-content'>
				{ props.content }
				{ props.button && 
					<p className="btn--wrapper text-center">
						<Link to='/about-the-system/methodology' className="btn-default btn-main-color text-center ">{ props.button }</Link>
					</p>
				}
			</div>
		</div>
	)
}

const Methodology = props => {

	const [methodology, setMethodology] = useState(null);

	const methodologyDataLoad = (pSection, pIndicatorID) => {
		getMethodologyData(pSection, pIndicatorID).then((data) => {
			if (props.dataset == undefined && props.subsection == undefined)
			{
				// The dataset is not defined, all the received indicators are going to be painted
				setMethodology(data.resultset);
			}
			else if (props.dataset != undefined && props.subsection != undefined)
			{
				// In the physical risk section, there are more than one spider chart and/or bar chart
				if (props.subsection == 'vibrations-loud-noise-and-temperature')
				{
					// The indicators shown in the chart in Physical Risk -> Vibrations, loud noise and temperatures
					const indicators = [67,68,69,70];
					setMethodology( data.resultset.filter(indicator=> indicators.indexOf(indicator.indicatorID) > -1) );
				}
				else if (props.subsection == 'ergonomic-risks')
				{
					// The Physical Risk -> Ergonomic Risks chart has a Select to change the Dataset
					let dataset = props.dataset == 'esener' ? props.dataset.toUpperCase() : 'European Working Conditions Survey (EWCS)';
					// The indicators shown for both datasets in the chart
					const indicators = [90,91,92,93,94,291,292,386];
					setMethodology( data.resultset.filter(indicator=> (indicators.indexOf(indicator.indicatorID) > -1) && indicator.dataset==dataset) );
				}
			}
			else if (props.dataset == undefined && props.subsection != undefined)
			{
				if (props.subsection == 'sanctions-impact')
				{
					// The indicators shown in the map for Enforcement Capacity
					const indicators = [436,437,438,439,440];
					setMethodology( data.resultset.filter(indicator=> (indicators.indexOf(indicator.indicatorID) > -1)) );
				}
			}
			else
			{
				// The dataset is defined, the indicators displayed are the ones for the selected dataset
				let dataset = props.dataset == 'esener' ? props.dataset.toUpperCase() : 'European Working Conditions Survey (EWCS)';
				setMethodology( data.resultset.filter(indicator=> indicator.dataset==dataset) )
			}
		})
	}

	useEffect(() => {
		methodologyDataLoad(props.section, props.indicator);
	}, [props.indicator, props.dataset, props.subsection])

	const methodologySection = (numberOfIndicators, headerLiteralID, dataLiteralID) => {
		if (props.literals[dataLiteralID] != null && props.literals[dataLiteralID] != 'null' && props.literals[dataLiteralID] != '' 
			&& props.literals[dataLiteralID].length > 0 && numberOfIndicators > 0)
		{
			return (
				<Fragment>
					{(numberOfIndicators == 1) ? (<h3>{props.literals[headerLiteralID]}</h3>) : (<h4>{props.literals[headerLiteralID]}</h4>)}
					{ReactHtmlParser(props.literals[dataLiteralID])}
				</Fragment>
			)
		}
		return null;
	}

	let methodologyContent = '';

	if (methodology != undefined)
	{
		if (methodology.length > 1)
		{
			methodologyContent = (
				<div>
					{methodology.map((pMethodology, index) => (
						<Accordion key={`${index}-${pMethodology.dataset}`} level={2} title={ props.literals[`L${pMethodology.diagram}`] } content={
							<React.Fragment>
								{ methodologySection(methodology.length,'L20720',`L${methodology[index].diagram}`) }
								{ methodologySection(methodology.length,'L20721',`L${methodology[index].description}`)}
								{ methodologySection(methodology.length,'L20722',`L${methodology[index].datasource}`)}
								{ methodologySection(methodology.length,'L20723',`L${methodology[index].specificTable}`)}
								{ methodologySection(methodology.length,'L20724',`L${methodology[index].url}`)}
								{ methodologySection(methodology.length,'L20728',`L${methodology[index].options_applied}`)}
								{ methodologySection(methodology.length,'L20725',`L${methodology[index].referenceYear}`)}
								{ methodologySection(methodology.length,'L20726',`L${methodology[index].lastUpdate}`)}
								{ methodologySection(methodology.length,'L20727',`L${methodology[index].coverage}`)}
								{ methodologySection(methodology.length,'L20730',`L${methodology[index].unitMeasure}`)}
								{ methodologySection(methodology.length,'L20729',`L${methodology[index].calculations}`)}
								{ methodologySection(methodology.length,'L20731',`L${methodology[index].visualisation}`)}
								{ methodologySection(methodology.length,'L20732',`L${methodology[index].additionalComments}`)}
							</React.Fragment>								
						}/>
					))}
				</div>
			)
		}
		else if (methodology.length == 1)
		{
			methodologyContent = (
				<div>
					{ methodologySection(methodology.length,'L20720',`L${methodology[0].diagram}`) }
					{ methodologySection(methodology.length,'L20721',`L${methodology[0].description}`) }
					{ methodologySection(methodology.length,'L20722',`L${methodology[0].datasource}`) }
					{ methodologySection(methodology.length,'L20723',`L${methodology[0].specificTable}`) }
					{ methodologySection(methodology.length,'L20724',`L${methodology[0].url}`) }
					{ methodologySection(methodology.length,'L20728',`L${methodology[0].optionsApplied}`) }
					{ methodologySection(methodology.length,'L20725',`L${methodology[0].referenceYear}`) }
					{ methodologySection(methodology.length,'L20726',`L${methodology[0].lastUpdate}`) }
					{ methodologySection(methodology.length,'L20727',`L${methodology[0].coverage}`) }
					{ methodologySection(methodology.length,'L20730',`L${methodology[0].unitMeasure}`) }
					{ methodologySection(methodology.length,'L20729',`L${methodology[0].calculations}`) }
					{ methodologySection(methodology.length,'L20731',`L${methodology[0].visualisation}`) }
					{ methodologySection(methodology.length,'L20732',`L${methodology[0].additionalComments}`) }
				</div>
			)
		}
	}

	return(
		<section className="container section--page section--methodology ng-isolate-scope">
			<Accordion level={1} title={props.literals.L22101} button={props.literals.L22102} content={ methodologyContent } />
		</section>
	)
}

export default Methodology;